import { isManagerRole } from "../../helpers/roles";
import { useEffect, useState } from "react";
import {ARR_RANGES, SOURCE_OPTIONS, STATUS_OPTIONS, TIMEZONE} from "../../constans";
import Select, {components} from "react-select";
import { prTableSelectStyles } from "../../constants/prTableSelectStyles";
import {ChevronDown} from "lucide-react";
import dayjs from "dayjs";
import {Button, Form, InputGroup} from "react-bootstrap";
import {AppCheckbox, CheckboxHolder} from "../form";
import FilterOrder from "../FilterOrder/FilterOrder";
import timezone from "dayjs-timezone-iana-plugin";
import DatePicker from "react-datepicker";

dayjs.extend(timezone);

function managerFilterLabel(profile, username, keycrmId) {
    const name = [profile?.firstName, profile?.lastName].filter(Boolean).join(" ").trim();
    return name || username || String(keycrmId);
}

/**
 * Компонент для відображення шапки з фільтрами, управлінням датами, валютою тощо
 */
const HeaderControls = ({
                            usdBuyRate,
                            usdSellRate,
                            currency,
                            setCurrency,
                            range,
                            setRange,
                            isLoading,
                            onRangeSelected,
                            handleCheckboxChange,
                            isChecked,
                            selectedManagers,
                            setSelectedManagers,
                            tagFilterMode,
                            setTagFilterMode,
                            selectedSources,
                            selectedStatuses,
                            toggleSource,
                            toggleStatus,
                            onApplyRange,
                            onQuickRangeSelect
                        }) => {
    const [managerOptions, setManagerOptions] = useState([]);

    useEffect(() => {
        fetch("/api/users/directory", { credentials: "include" })
            .then((r) => (r.ok ? r.json() : []))
            .then((list) => {
                const byId = new Map();
                (Array.isArray(list) ? list : []).forEach((u) => {
                    if (!isManagerRole(u.role)) return;
                    const raw = u.profile?.keycrmManagerId;
                    if (raw === null || raw === undefined || raw === "") return;
                    const id = Number(raw);
                    if (Number.isNaN(id)) return;
                    if (byId.has(id)) return;
                    byId.set(id, {
                        value: id,
                        label: managerFilterLabel(u.profile, u.username, id),
                    });
                });
                const opts = [...byId.values()].sort((a, b) =>
                    a.label.localeCompare(b.label, "uk")
                );
                setManagerOptions(opts);
            })
            .catch(() => setManagerOptions([]));
    }, []);

    const handleManagerChange = (selectedOptions) => {
        setSelectedManagers(selectedOptions.map((option) => option.value));
    };

    // Кастомний компонент для іконки випадаючого списку
    const DropdownIndicator = (props) => (
        <components.DropdownIndicator {...props}>
            <ChevronDown size={20} color="#888" />
        </components.DropdownIndicator>
    );

    // Функції вибору діапазонів дат
    const getToday = () => {
        const today = dayjs().tz(TIMEZONE).startOf("day");
        const endOfToday = today.endOf("day");
        onQuickRangeSelect({
            startDate: today.utc().toDate(),
            endDate: endOfToday.utc().toDate(),
        });
    };

    const getYesterday = () => {
        const yesterday = dayjs().tz(TIMEZONE).subtract(1, "day").startOf("day");
        const endOfYesterday = yesterday.endOf("day");
        onQuickRangeSelect({
            startDate: yesterday.utc().toDate(),
            endDate: endOfYesterday.utc().toDate(),
        });
    };

    const getLastNDays = (n) => {
        const today = dayjs().tz(TIMEZONE);
        const startDate = today.subtract(n, "days").startOf("day").utc().toDate();
        const endDate = today.subtract(1, "day").endOf("day").utc().toDate();

        onQuickRangeSelect({ startDate, endDate });
    };

    const getLast3Days = () => getLastNDays(3);
    const getLast7Days = () => getLastNDays(7);

    const getLastWeek = () => {
        const today = dayjs().tz(TIMEZONE);
        const startOfLastWeek = today.startOf("isoWeek").subtract(1, "week"); // Понедельник прошлой недели
        const endOfLastWeek = startOfLastWeek.endOf("isoWeek");               // Воскресенье прошлой недели

        onQuickRangeSelect({
            startDate: startOfLastWeek.utc().toDate(),
            endDate: endOfLastWeek.utc().toDate(),
        });
    };

    const getCurrentMonth = () => {
        const today = dayjs().tz(TIMEZONE).startOf("month");
        const endOfMonth = today.endOf("month");
        onQuickRangeSelect({
            startDate: today.utc().toDate(),
            endDate: endOfMonth.utc().toDate(),
        });
    };

    const getLastMonth = () => {
        const today = dayjs().tz(TIMEZONE).subtract(1, "month").startOf("month");
        const endOfMonth = today.endOf("month");
        onQuickRangeSelect({
            startDate: today.utc().toDate(),
            endDate: endOfMonth.utc().toDate(),
        });
    };

    return (
        <div className="header-orders container mt-4">
            <div className="currency-holder">
                <div>
                    {usdBuyRate !== null && usdSellRate !== null ? (
                        <span>
              USD: {usdBuyRate.toFixed(2)} / {usdSellRate.toFixed(2)}
            </span>
                    ) : (
                        <span>Завантаження курсу...</span>
                    )}
                </div>
                <div className="currency-switch">
                    <span>₴</span>
                    <label className="switch">
                        <input
                            type="checkbox"
                            checked={currency === "USD"}
                            onChange={() =>
                                setCurrency(currency === "UAH" ? "USD" : "UAH")
                            }
                        />
                        <span className="slider"></span>
                    </label>
                    <span>$</span>
                </div>
            </div>
            <div className="section-controls">
                <InputGroup className="mb-3">
                    <div className="holder-datapickers">
                        <DatePicker
                            dateFormat="dd.MM.yyyy"
                            locale="uk"
                            selected={range.startDate}
                            onChange={(date) =>
                                setRange((prev) => ({ ...prev, startDate: date }))
                            }
                        />
                        <DatePicker
                            dateFormat="dd.MM.yyyy"
                            locale="uk"
                            selected={range.endDate}
                            onChange={(date) =>
                                setRange((prev) => ({ ...prev, endDate: date }))
                            }
                        />
                    </div>
                    <FilterOrder
                        options={ARR_RANGES}
                        filterValueSelected={onRangeSelected}
                    />
                    <AppCheckbox
                        id="header-pr-verify"
                        label="Перевірка"
                        checked={isChecked}
                        onChange={handleCheckboxChange}
                    />
                </InputGroup>
                <div className="date-buttons">
                    <Button variant="outline-dark" disabled={isLoading} onClick={onApplyRange}>
                        {isLoading ? "Завантаження…" : "Оновити"}
                    </Button>
                    <Button variant="outline-dark" onClick={getToday} disabled={isLoading}>
                        Сьогодні
                    </Button>
                    <Button variant="outline-dark" onClick={getYesterday} disabled={isLoading}>
                        Вчора
                    </Button>
                    <Button variant="outline-dark" onClick={getLast3Days} disabled={isLoading}>
                        3 дні
                    </Button>
                    <Button variant="outline-dark" onClick={getLast7Days} disabled={isLoading}>
                        7 днів
                    </Button>
                    <Button variant="outline-dark" onClick={getLastWeek} disabled={isLoading}>
                        Минулого тижня
                    </Button>
                    <Button variant="outline-dark" onClick={getCurrentMonth} disabled={isLoading}>
                        Поточний місяць
                    </Button>
                    <Button variant="outline-dark" onClick={getLastMonth} disabled={isLoading}>
                        Минулий місяць
                    </Button>
                </div>
                <div className="date-buttons">
                    <Select
                        isMulti
                        options={managerOptions}
                        value={managerOptions.filter((option) =>
                            selectedManagers.includes(option.value)
                        )}
                        onChange={handleManagerChange}
                        styles={prTableSelectStyles}
                        placeholder="Оберіть менеджерів..."
                        components={{ DropdownIndicator }}
                    />
                </div>
                <div className="date-buttons">
                    <Form.Select
                        value={tagFilterMode}
                        onChange={(e) => setTagFilterMode(e.target.value)}
                    >
                        <option value="all">Усі замовлення</option>
                        <option value="no_opt">Без опту</option>
                        <option value="no_barter">Без бартерів</option>
                        <option value="no_both">Без бартерів і без опту</option>
                        <option value="only_barter">Лише бартер</option>
                        <option value="only_opt">Лише опт</option>
                    </Form.Select>
                </div>
                <CheckboxHolder>
                    {SOURCE_OPTIONS.map(({ id, label }) => {
                        const checkboxId = `option-${label.replace(/\s+/g, "-")}`;

                        return (
                            <AppCheckbox
                                key={label}
                                id={checkboxId}
                                label={label}
                                checked={id.some((sourceId) => selectedSources.includes(sourceId))}
                                onChange={() => toggleSource(id)}
                            />
                        );
                    })}
                </CheckboxHolder>
                <CheckboxHolder>
                    {STATUS_OPTIONS.map(({ status_group_id, label }) => {
                        const checkboxId = `option-${label.replace(/\s+/g, "-")}`;

                        return (
                            <AppCheckbox
                                key={status_group_id}
                                id={checkboxId}
                                label={label}
                                checked={selectedStatuses.includes(status_group_id)}
                                onChange={() => toggleStatus(status_group_id)}
                            />
                        );
                    })}
                </CheckboxHolder>
            </div>
        </div>
    );
};

export default HeaderControls;
